import React, { useEffect, useState } from "react";
import JoinPosterService from "../../api/services/JoinPoster";
import { authUrls } from "../../dataUI/common/commonConsts";
import { useTranslation } from "react-i18next";
import IframePosterConfirm from "./IframePosterConfirm/IframePosterConfirm";
import IframePosterMerchant from "./IframePosterMerchant/IframePosterMerchant";
import GlobalLoader from "../../components/UI/GlobalLoader/GlobalLoader";
import { JoinposterIframeNavigation_tabsTypes } from "../../dataUI/common/merchant";
import JoinPosterAssortment from "./JoinPosterAssortment/JoinPosterAssortment";

const JoinPosterIframe = ({ selectedTabType }) => {
  const { t } = useTranslation();
  const [stores, setStores] = useState(undefined);
  const [merchantInit, setMerchantInit] = useState(undefined);
  const [syncData, setSyncData] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const url = window.document.location.href;
    const code = url.includes(authUrls.IFRAME)
      ? url.split(authUrls.IFRAME)[1]
      : undefined;
    code && getMerchantData(code);
  }, []);

  const getMerchantData = async (code) => {
    const resp = await JoinPosterService.getMerchantData(code);
    resp.data.spots && setStores(resp.data.spots);

    const merchantRespInit = {
      id: resp.data.merchant.id,
      name: resp.data.merchant.name,
      description: resp.data.merchant.description,
      logo: resp.data.merchant.logo,
      category_ids: resp.data.merchant.category_ids,
    };

    setMerchantInit({ ...merchantRespInit });
    setSyncData({
      account: resp.data.account_name,
      token: resp.data.access_token,
    });
  };

  const synchronizeMerchant = async () => {
    setIsLoading(true);
    const resp = await JoinPosterService.synchronizeMerchant(
      syncData.token,
      syncData.account,
    );
    const merchantRespInit = {
      id: resp.data.merchant.id,
      name: resp.data.merchant.name,
      description: resp.data.merchant.description,
      logo: resp.data.merchant.logo,
      category_ids: resp.data.merchant.category_ids,
    };
    setMerchantInit(merchantRespInit);
    setIsLoading(false);
    resp.data.spots && setStores(resp.data.spots);
  };

  const renderMerchantPage = () => {
   return stores.length ? (
      <IframePosterMerchant
        stores={stores}
        merchant={merchantInit}
        synchronizeMerchant={synchronizeMerchant}
        selectedTabType={selectedTabType}
      />
    ) : (
      <IframePosterConfirm
        syncData={syncData}
        synchronizeMerchant={synchronizeMerchant}
        selectedTabType={selectedTabType}
      />
   )
  }

  const renderPage = () => {
    switch (selectedTabType) {
      case JoinposterIframeNavigation_tabsTypes.BASIC_DATA: {
       return renderMerchantPage()
      }
      case JoinposterIframeNavigation_tabsTypes.ASSORTMENT: {
        return <div className='IframePosterMerchantPage'>
          <JoinPosterAssortment merchantId={merchantInit?.id}/>
        </div>
      }
    }
  }

  if(!stores || !merchantInit || !syncData || isLoading) return (
    <GlobalLoader />
  )
  return renderPage();
};

export default JoinPosterIframe;
